module.exports = __webpack_public_path__ + "img/web_01_1.e698bc84.jpg";